import { gql } from "@apollo/client";

export const ADD_STUDENT_PAYMENT = gql`
  mutation AddPayment($input: AddPaymentInput) {
    addPayment(input: $input) {
      status
      message
    }
  }
`;


export const GET_INVOICE_BY_STUDENT_PAGINATION = gql`
  query Data($studentId: ID, $classId: ID, $programId: ID, $academicYearId: ID, $invoiceId: Int, $keyword: String, $limit: Int, $page: Int) {
    getInvoiceWithPagination(studentId: $studentId, classId: $classId, programId: $programId, academicYearId: $academicYearId, invoiceId: $invoiceId, keyword: $keyword, limit: $limit, page: $page) {
      data {
        _id
        schoolId {
          _id
          schoolName
        }
        academicYearId {
          _id
          academicYear
          academicYearInKhmer
        }
        groupFeeType
        paymentDate
        paymentMethod
        isDiscount
        studentId {
          _id
          lastName
          studentEnglishName
          firstName
          gender
        }
        billTo {
          _id
          englishName
          firstName
          gender
          lastName
          tel
        }
        classId {
          _id
          className
          classGroupId {
            _id
            classGroupName
            classGroupNameEn
          }
        }
        month
        grossAmount
        netAmount
        updatedAt
        invoiceId
        startDate
        endDate
        discountAmount
        void
        isRefund
        programId {
          _id
          programmName
          programmNameEn
        }
        quarter
        exchangeRate
        totalAmounts
        additionalFee {
          additionalFeeTotal
          total
        }
        createdAt
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;




export const GET_STUDENT_PAYMENT_PAGINATION = gql`
  query GetPaymentPagination($page: Int!, $limit: Int!, $studentId: ID!) {
    getPaymentPagination(page: $page, limit: $limit, studentId: $studentId) {
      data {
        _id
        inv
        date
        total
        void
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const GET_STUDENT_PAYMENT_BY_MONTH = gql`
  query GetStudentsPaymentByMonth(
    $page: Int!
    $limit: Int!
    $service: ID!
    $month: String!
    $year: String!
  ) {
    getStudentsPaymentByMonth(
      page: $page
      limit: $limit
      service: $service
      month: $month
      year: $year
    ) {
      data {
        _id
        student_id
        firstName
        lastName
        englishName
        gender
        profileImg
        dob
        service
        toPay
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const GET_PAYMENT_PRICE = gql`
  query GetPaymentPeices($classId: ID!) {
    getPaymentPeices(classId: $classId) {
      _id
      feeID
      duration
      price
      afterDicount
      discountPercentage
      discountPrice
    }
  }
`;

export const GET_STUDENT_PAYMENT_BY_ID = gql`
  query GetPaymentById($id: ID!) {
    getPaymentById(_id: $id) {
      _id
      inv
      billToId
      billTo
      paymentDate
      vattIn
      studentInfo {
        fullName
        khmerId
        latinName
        dateOfBirth
        shift
        tel
        gender
        grade
      }
      payments {
        fee
        feeType
        description
        startDate
        endDate
        qty
        amount
        totalAmount
      }
      totalUSD
      totalKHR
    }
  }
`;

export const VOID_STUDENT_PAYMENT = gql`
  mutation VoidPayment($id: ID) {
    voidPayment(_id: $id) {
      status
      message
    }
  }
`;


export const REFUND_STUDENT_INVOICE = gql`
  mutation CreateRefund($input: RefundInput) {
    createRefund(input: $input) {
      message
      status
    }
  }
`;


export const GET_NEXT_INV = gql`
  query Query {
    getNextInvoiceNumbering
  }
`;
